import React from 'react';
import { AntTooltip } from './AntTooltip';
import { EkaCareIcon } from './Icons';
import { getAgeString } from '../../store/utils';
import {
    NewPatient,
    Patient,
    getPtFullName,
    getPtFullNameWithSalutation,
} from '../../store/types/patient';
import { addAlpha, getColorForString } from '../../pages/utils';

function getAgeStr(pt: Patient) {
    const age = getAgeString({
        age: pt.personal.age?.value,
        month: pt.personal.age?.month,
        dob: pt.personal.age?.dob,
    });

    if (age === '') {
        return '';
    } else {
        return `${age} | `;
    }
}

export const MergePtListItemViewOnlyContent: React.FC<{
    pt: Patient;
    className: string;
}> = (props) => {
    const { pt } = props;

    return (
        <div className={`flex gap-8 ${props.className}`}>
            <div className="font-lato text-darwin-neutral-800">{`${
                pt['personal']['phone']?.['c'] || ''
            }${pt['personal']['phone']?.['n'] || ''}`}</div>
            <div className="relative top-9">
                <svg
                    width="4"
                    height="4"
                    viewBox="0 0 4 4"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <circle cx="2" cy="2" r="2" fill="#505775" />
                </svg>{' '}
            </div>
            <div className="font-lato text-darwin-neutral-800">
                {pt.personal.age && getAgeStr(pt)}
                {pt.personal.gender &&
                    `${pt.personal.gender[0].toUpperCase()}${pt.personal.gender.slice(1)}`}
            </div>
        </div>
    );
};

export const MergePtListItemViewOnly: React.FC<{ pt: Patient }> = (props) => {
    const { pt } = props;
    const ptNameText = getPtFullName(pt);
    const color = getColorForString(ptNameText);

    return (
        <button className="flex items-start space-x-8 text-14 text-darwin-neutrals-1000">
            <span
                style={{ color: color, backgroundColor: addAlpha(color, 0.1) }}
                className="rounded-full w-24 h-24 min-w-24 min-h-24 text-12 font-700 flex items-center justify-center"
            >
                <span>
                    {pt.personal.name.f && pt.personal.name.f[0]}
                    {pt.personal.name.l && pt.personal.name.l[0]}
                </span>
            </span>
            <span className="relative top-2 text-left">
                <span className="font-700 break-words">
                    <span>{getPtFullNameWithSalutation(pt)}</span>{' '}
                    {pt.archived && <span>(Archived)</span>}
                </span>
            </span>
        </button>
    );
};

const MergePtListItem: React.FC<{
    info: NewPatient & { _name?: string; _phone?: string; _uhid?: string | number };
}> = (props) => {
    const { info } = props;
    return (
        <div className="inline-flex flex-col rounded-4">
            <p style={{ display: 'flex' }}>
                {info.personal.onApp && (
                    <AntTooltip content="Connected on eka.care app">
                        <span className="relative top-3 mr-3 w-16 h-16">
                            <EkaCareIcon />
                        </span>
                    </AntTooltip>
                )}
                <span className="font-700">{info['_name']}</span>
                {info.personal.gender && info.personal.gender[0] && (
                    <span>
                        {`, ${info.personal.gender[0].toUpperCase()}${info.personal.gender.slice(
                            1,
                        )}`}
                    </span>
                )}
                {info.personal.age && (
                    <span>
                        {`${getAgeString(
                            {
                                age: info.personal.age.value,
                                month: info.personal.age.month,
                                dob: info.personal.age.dob,
                            },
                            ', ',
                        )}`}
                    </span>
                )}
            </p>
            <div className="flex gap-10">
                {info['_phone'] && (
                    <p>
                        <span>Ph: </span>
                        {info['_phone']}
                    </p>
                )}
                {info['_uhid'] && (
                    <p>
                        <span>UHID: </span>
                        {info['_uhid']}
                    </p>
                )}
            </div>
        </div>
    );
};

export default MergePtListItem;
